export const validation = {
  mainTitleMaxChar: 50,
  titleMaxChar: 200,
  paragraphMaxChar: 1500,
  buttons: {
    min: 0,
    max: 2
  }
}
